import React, { Component } from 'react';
import Modal from '../components/Modal';
import StagesManager from '../components/StagesManager';
import ButtonAnimated from '../components/buttons/ButtonAnimated';
import FixedView from '../components/FixedView';
import { checkTranslation, translate } from '../utils/useful';
// import FormViewer from '../components/FormViewer';
// import { siteConfig } from '../variables/config';
// import { QRCode } from 'react-qrcode-logo';
// import TextAreaInput from '../components/inputs/TextAreaInput';
// import HttpServices from '../utils/Http.services';
// import PermissionsView from '../components/PermissionsView';
// import ActionsBtn from '../components/partials/ActionsBtn';
import ActionButton from '../components/partials/ActionButton';
// import SelectInput from '../components/inputs/SelectInput';
import SideActionsList from '../components/SideActionsList';
import AddActionFromApplet from '../components/AddActionFromApplet';
import RemoveConfirmationModal from './RemoveConfirmationModal';

class ActionsConfigModal extends Component {

    state = {
        shareOptions: [
            { key: 'appletAccess', title: '{{lang}}Anyone with Applet Access ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/2peoples.svg', },
            { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/applets/drive/earth.svg', },
        ],
        // shareOptions: [
        //     // { key: 'collaborators', title: '{{lang}}Only collaborators of the document can access via link', icon: '/assets/icons/applets/drive/2peoples.svg', },
        //     // { key: 'organizationView', title: '{{lang}}People in the organization with the link ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/organization.svg', },
        //     // { key: 'organizationEdit', title: '{{lang}}People in the organization with the link ', access: '{{lang}}can edit', icon: '/assets/icons/applets/drive/organization.svg', },
        //     { key: 'appletAccess', title: '{{lang}}Anyone with Applet Access ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/earth.svg', },
        //     { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/applets/drive/earth.svg', },
        //     // { key: 'AnyoneEdit', title: '{{lang}}Anyone with the link ', access: '{{lang}}can edit', icon: '/assets/icons/applets/drive/earth.svg', },
        // ],
        currentShare: 0,
        headers: [
            { type: 'GlobalUserMultiInput', key: 'allowed', information: { address: 'searchUser', filter: {}, helperKey: 'hub._id', fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
        ],
        headersLink: [
            { type: 'GlobalUserMultiInput', key: 'link', information: { address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
            { type: 'SelectInput', key: 'applet', information: { isSearchable: true, label: '{{lang}}Applet', address: 'getMyFramesByType', filter: { features: 'Drive' }, fields: { title: 'applet.name', value: '_id' }, type: 'api', root: null, placeholder: '{{lang}}Select applet', required: false } },
        ],
        headersNotif: [
            { type: 'TextAreaInput', key: 'notif', information: { placeholder: '{{lang}}Add a note (Message will be sent to Yonnect messenger)', required: false, disabled: false } },
        ],
        qrCodeLink: '',
        link: '',
        showYonnect: false,
        showQRCode: false,
        params: [],
        notif: true
    }

    componentDidMount() {
        // console.log('mylink',this.props.currentItem)
        // this.props.setLink(this.props.currentItem)
        // this.init()
        this.createParams()


    }


    componentDidUpdate(prevProps) {
        // if (this.props.admins && JSON.stringify(this.props.admins) != JSON.stringify(prevProps.admins)) {
        //     this.init()
        // }
        if (prevProps.fields != this.props.fields) {
            this.createParams()
        }
    }


    createParams = () => {

        let params = []
        if (this.props.fields) {

            let myParams = { label: "Single Record", value: '*record', fields: JSON.parse(JSON.stringify(this.props.fields)), info: {} }


            let foundId = false

            for (let a = 0; a < myParams.fields.length; a++) {
                const element = myParams.fields[a];
                if (element?.key == '_id') {
                    foundId = true
                }
            }

            if (!foundId) {
                myParams.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                myParams.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                myParams.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
            }


            if (myParams) {
                params.splice(0, 0, myParams)
            }
        }


        this.setState({ params })
    }


    submit = () => {
        this.modal.hideModal()
    }


    open = () => {
        this.modal.showModal()
        this.init()
        setTimeout(() => {
            this.setState({ showFixed: true })
        }, 10);
    }


    init = () => {

        // TO DO: fetch applet permissions
        this.setState({ admins: [] })
    }


    setAdmins = (admins, cb) => {
        this.setState({ admins }, () => {
            if (cb) {
                cb()
            }
        })
    }


    fetchRemove = () => {

    }

    openRemoveModal = (action) => {
        this.removeModal.modal.showModal()
        this.setState({ currentAction: action })
    }

    openEditModal = (action) => {

    }

    changeSidebar = (name, type) => {

        if (name == 'frameActions' && type == 'close') {

            this.closeAddActionModal()

        }
    }

    closeAddActionModal = () => {
        this.addActionModal.close()
    }

    render() {

        let colors = this.props.colors


        return (

            <>
                <Modal maxWidth={400} ref={(el) => this.modal = el} zIndex={10}>
                    <div className="w-100 br-10" style={{ backgroundColor: "#fff", overflow: 'hidden' }} >
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                            <div className="" stage={0} stageName={'init'}>
                                <div className='pb-5'>
                                    <div className="pb-1 pt-1 px-3  flexcb top-0" style={{ position: 'sticky', backgroundColor: '', borderBottom: '1px solid #eee' }}>
                                        <p className="mt-0 text-normal text-bold">{translate('Frame actions')}</p>

                                        <ButtonAnimated
                                            // iconwidth='24px'
                                            onClick={() => { this.submit() }}
                                            title={translate('Submit')}
                                            icon='/assets/icons/arrow-right-white.svg'
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background}
                                            isLoading={this.state.isLoading}
                                        />
                                    </div>

                                    <div className='px-3 pt-2'>



                                        {/* <p className='text-small text-semibold mb-2 px-1'>{translate("Actions source")}</p>
                                        <div className='bordered-input'>
                                            <SelectInput changeValue={this.changeValue} header={{ key: 'sync', information: { type: 'local', items: [{ value: 'default', title: '{{lang}}Default' }, { value: 'sameAsHub', title: '{{lang}}Same as hub' }, { value: 'custom', title: '{{lang}}Custom' }], isSearchable: true, placeholder: '{{lang}}Select', required: true } }} />
                                        </div> */}

                                        <div className='mb-1 '>
                                            <button onClick={(e) => { e.stopPropagation(); this.plusFixedView.showView() }} ref={el => this.plusBut = el} className='text-link br-4 px-0 py-1' style={{ border: '0px solid #007aff' }}>
                                                <p>{translate("+ Add action")}</p>
                                            </button>
                                        </div>

                                        {this.state.showFixed && (
                                            <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={this.props.fullSize ? -30 : 0} maxWidth={200} >
                                                <div className='bg-white br-10 py-3 px-3 shadow-3 sc-gray2 d-flex flex-column'>

                                                    <button onClick={() => this.addActionModal.showModal()} className='text-link text-start br-4 px-0 py-1 mb-1' style={{ border: '0px solid #007aff' }}>
                                                        <p>{translate("+ Add new action")}</p>
                                                    </button>
                                                    <p className='text-smallest color-gray-2 mb-1'>{translate("You can create a new action from scratch.")}</p>

                                                    <button onClick={() => this.addActionFromApplet.open()} className='text-link text-start br-4 px-0 py-1' style={{ border: '0px solid #007aff' }}>
                                                        <p>{translate("+ Add from applet actions")}</p>
                                                    </button>

                                                    <p className='text-smallest color-gray-2 mb-0'>{translate("You can use available actions of the this applet in this frame.")}</p>

                                                </div>
                                            </FixedView>
                                        )}

                                        <div className='px-0'>
                                            {Array.isArray(this.props.initData) && this.props.initData?.map((action, index) => {
                                                return (
                                                    <div key={index} className='pt-2 pb-2' style={{ borderBottom: '1px solid #f2f2f2' }}>
                                                        <ActionRow data={action} openRemoveModal={this.openRemoveModal} openEditModal={this.openEditModal} />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>

                </Modal>



                <Modal width={this.props.width} maxWidth={400} zIndex={40} ref={el => this.addActionModal = el} >
                    <div className={'h-100 scroll-no-scrollbar pb-5 br-8 '} style={{ backgroundColor: '#fff', }}>
                        <SideActionsList functionsHandler={this.props.functionsHandler} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={colors?.background} page={this.props.page} variables={this.state.variables ?? this.props.variables} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} changeSidebar={this.changeSidebar} headers={this.props.headers} params={this.state.params} />
                    </div>
                </Modal>


                <AddActionFromApplet initData={this.props.initData} ref={el => this.addActionFromApplet = el} functionsHandler={this.functionsHandler} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={colors?.background} page={this.props.page} variables={this.state.variables ?? this.props.variables} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} changeSidebar={this.changeSidebar} headers={this.props.headers} params={this.state.params} applet={this.props.applet} />


                <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.fetchRemove} />


            </>
        )
    }
}




class ActionRow extends Component {




    render() {


        return (
            <div className='flexc'>
                <div className='flexcc'>

                    <ActionButton>
                        <div className="  pt-2 pb-2 px-3 d-flex flex-column w-100" style={{ minWidth: 160, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>


                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.data)}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('View / Edit')}</p>

                            </button>

                            {/* <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.data)}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Edit')}</p>

                            </button> */}

                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openRemoveModal(this.props.data)} >
                                <img src='/assets/icons/useful/trash.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Remove')}</p>

                            </button>

                        </div>
                    </ActionButton>

                </div>
                <div className='mld-2 flexcb w-100'>
                    <div className='flexc'>
                        <p className='text-small text-semibold'>{checkTranslation(this.props.data?.name)}</p>
                        {/* <p className='text-smaller'>{this.props.data?.type}</p> */}
                    </div>

                    <div className='flexc'>

                        {/* <div className=' p-1 mld-0 flexcc ' style={{ opacity: 0.3 }}>
                            <img src={'/assets/icons/useful/padlock.png'} width={14} />
                        </div> */}

                        <div className='br-4 mld-2 px-2 py-1 text-smallest text-semibold color-gray-2' style={{ background: "#eee" }}>{translate(this.props.data?.name)}</div>
                        <div className='br-4 mld-2 px-2 py-1 text-smallest text-semibold color-gray-2' style={{ background: "#eee" }}>{translate("Custom")}</div>

                    </div>

                </div>




            </div>
        )
    }

}


export default ActionsConfigModal;